/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';
import Carousel from 'antd/lib/carousel';
import Icon from 'antd/lib/icon';
import classNames from 'classnames';

import { additionsClasses } from '../../../utils';

import commonStyle from './Carousel.module.scss';

const PrevArrow = ({ style, onClick, ...rest }) => (
  <div className={ style['prev-button'] } onClick={ onClick }>
    <Icon type="left" { ...rest } />
  </div>
);

const NextArrow = ({ style, onClick, ...rest }) => (
  <div className={ style['next-button'] } onClick={ onClick }>
    <Icon type="right" { ...rest } />
  </div>
);

export const CustomCarousel = ({ style = commonStyle, additions, arrows = false, ...props }) => {

  const settings = {
    // className: 'center',
    // centerMode: true,
    infinite: true,
    // centerPadding: '60px',
    // slidesToShow: 3,
    speed: 500
    // rows: 2,
    // slidesPerRow: 2
  };

  return (
    <div className={ classNames(style.wrapper, additionsClasses(additions, style)) }>
      <Carousel
        arrows={ arrows }
        { ...props }
        prevArrow={ <PrevArrow style={ style } /> }
        nextArrow={ <NextArrow style={ style } /> }
        { ...settings }
      />
    </div>
  );

};
